import React, { useEffect, useState } from 'react';
import ViewBillImage from './modals/viewBill';
import ReactToPrint from 'react-to-print';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectBillInvoiceId } from '../Redux/billing';
import {
  selectCompanyAddress,
  selectDefultProfileSetting,
  selectPrefix,
} from '../Redux/profile';
import { selectToken } from '../Redux/security';
import axios from 'axios';
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../Redux/modal';
import Lottie from 'lottie-react';
import spinner from '../../utility/json/Spinner.json';
import { toJpeg, toPng } from 'html-to-image';
import jsPDF from 'jspdf';
import { FormatNumber2 } from './tools';
import { DownloadFile, UploadFile } from './functions/firebase';
import { getMessageWallet } from '../func/common';
import { not_permisson_forWhastapp } from '../common';
import { CallAPIPromise } from '../func/func';
import {
  DownloadRounded,
  PrintRounded,
  SmsOutlined,
  WhatsApp,
} from '@mui/icons-material';
const ViewBill = () => {
  const componentRef = useRef();
  const prefix = useSelector(selectPrefix);
  const billInvoice = useSelector(selectBillInvoiceId);
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const [date, setDate] = useState();
  const [billSettlement, setBillSettlement] = useState([]);
  const [list, setList] = useState([]);
  const companyDetails = useSelector(selectCompanyAddress);
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  const getViewBillDetatils = () => {
    CallAPIPromise(
      '/api/billing/loadBill',

      {
        table_prefix: prefix,
        INVNO: billInvoice,
      }
    )
      .then((response) => {
        const dataList = response.data.response;
        console.log(dataList);
        setList(dataList);
        setDate(dataList[0].DATE);
        getViewBillSettelment();
      })
      .catch((err) => {
        if (err.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      });
    // .finally(() => {
    //   dispatch(setloading(false));
    // });
  };

  const getViewBillSettelment = () => {
    CallAPIPromise(
      '/api/billing/loadBillSettlement',

      {
        table_prefix: prefix,
        INVNO: billInvoice,
      }
    )
      .then((response) => {
        if (response.data.status === 200) {
          setBillSettlement(response.data.response);
        }
      })
      .catch((err) => {
        if (err.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(err);
      });
    // .finally(() => {
    //   dispatch(setloading(false));
    // });
  };

  const downloadPdf = () => {
    toJpeg(
      componentRef.current,
      window.innerWidth < 768 ? { quality: 0.25 } : { quality: 0.95 }
    )
      .then((dataUrl) => {
        const pdf = new jsPDF();
        pdf.addImage(dataUrl, 'PNG', 0, 0);
        pdf.save(`Bill_${billInvoice}`);
      })
      .catch((err) => console.log(err));
  };

  const defaultProfile = useSelector(selectDefultProfileSetting);
  function dataURLToBlob(dataUrl) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }
  const sendWhatsapp = (number, total) => {
    if (defaultProfile?.SEND_WHATSAPP === 'Y') {
      dispatch(setSpinnerLoading('sending image'));

      getMessageWallet(companyDetails.email, token)
        .then((bal) => {
          if (bal > 0) {
            if (number?.length === 10) {
              const amount = FormatNumber2(total);
              toJpeg(
                componentRef.current,
                window.innerWidth < 768 ? { quality: 0.25 } : { quality: 0.95 }
              )
                .then((dataUrl) => {
                  const blob = dataURLToBlob(dataUrl);
                  const path = 'tailoringx/bill/';
                  const name = `${prefix + billInvoice}`;
                  UploadFile(blob, path, name)
                    .then(() => {
                      const b = `tailoringx/bill/${prefix + billInvoice}`;
                      DownloadFile(b)
                        .then((c) => {
                          const s = c.split(
                            'https://firebasestorage.googleapis.com/v0/b/genius-office.appspot.com/'
                          );
                          const data = {
                            dataUrl: s[1],
                            invno: billInvoice.toString(),
                            mobile: number,
                            amount: amount,
                            company_email: companyDetails.email,
                          };
                          CallAPIPromise(
                            '/api/sendDigitalBill/saveBillImage',
                            data
                          )
                            .then((response) => {
                              dispatch(
                                setAlertWithTitle({
                                  title: 'Success',
                                  msg: 'Whatsapp is sent succesfully',
                                  lottie: 'success',
                                })
                              );
                            })
                            .catch((err) => {
                              console.log(err);

                              if (
                                err?.response?.data?.name ===
                                'TokenExpiredError'
                              ) {
                                dispatch(setSessionExpired(true));
                                dispatch(
                                  setAlertWithTitle({
                                    title: 'Whatsapp Sent',
                                    msg: 'Whastapp sent successfully',
                                  })
                                );
                              } else {
                                dispatch(
                                  setAlertWithTitle({
                                    title: 'ERROR',
                                    msg: 'Something went wrong.',
                                    lottie: 'reject',
                                  })
                                );
                              }
                            })
                            .finally(() => {
                              dispatch(setSpinnerLoading(false));
                            });
                        })
                        .catch(() => {
                          dispatch(setSpinnerLoading(false));
                        });
                    })
                    .catch((e) => {
                      console.log(e);
                      dispatch(setSpinnerLoading(false));
                    });
                })
                .catch((err) => {
                  console.log(err);
                  dispatch(setSpinnerLoading(false));
                });
            } else {
              dispatch(
                setAlertWithTitle({
                  title: 'Alert',
                  msg: 'Incorrect fields',
                })
              );
            }
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Alert',
                msg: 'Insufficient balance',
              })
            );
          }
        })
        .catch(() => {
          dispatch(
            setAlertWithTitle({
              title: 'Alert',
              msg: 'Insufficient balance',
            })
          );
        });
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: not_permisson_forWhastapp,
        })
      );
    }
  };
  useEffect(() => {
    getViewBillDetatils();
  }, []);
  const handleSendSms = (number, amount) => {
    if (defaultProfile?.SEND_SMS === 'Y') {
      dispatch(setSpinnerLoading('Sending'));
      getMessageWallet(companyDetails.email, token, true)
        .then((bal) => {
          if (bal > 0) {
            if (number?.length === 10 && amount) {
              const data = {
                INVNO: billInvoice,
                MOBILE: `+91${number}`,
                AMOUNT: amount,
                company_email: companyDetails.email,
                BILL_URL: '',
              };
              CallAPIPromise('/api/sendDigitalBill/sendSms', data)
                .then((response) => {
                  dispatch(
                    setAlertWithTitle({
                      title: 'Msg Sent',
                      msg: 'Message sent successfully',
                    })
                  );
                })
                .catch((err) => {
                  console.log(err);
                  dispatch(
                    setAlertWithTitle({
                      title: 'Error',
                      msg: 'Message Failed',
                    })
                  );
                })
                .finally(() => {
                  dispatch(setSpinnerLoading(false));
                });
            } else {
              dispatch(
                setAlertWithTitle({
                  title: 'Incorrect fields',
                })
              );
            }
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Alert',
                msg: 'Insufficient funds',
              })
            );
          }
        })
        .catch(() => {
          dispatch(setSpinnerLoading(false));
        });
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: not_permisson_forWhastapp,
        })
      );
    }
  };
  return (
    <div className="max-h-[calc(92vh-56px)] overflow-y-auto bg-slate-100 p-3 sm:p-4">
      {billSettlement[0] ? (
        <div className="grid gap-4 md:grid-cols-[minmax(0,1fr)_230px]">
          <div className="min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
            <ViewBillImage
              ref={componentRef}
              billSettlement={billSettlement}
              list={list}
              date={date}
              billInvoice={billInvoice}
            />
          </div>
          <aside className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Share invoice</p>
              <label htmlFor="invoice-mobile" className="mt-3 block text-xs font-semibold text-slate-700">Customer mobile</label>
              <input
                id="invoice-mobile"
                placeholder="Mobile"
                type="text"
                inputMode="numeric"
                value={list[0]?.MOBILE}
                readOnly
                className="mt-1.5 h-10 w-full rounded-lg border border-slate-300 bg-slate-50 px-3 text-sm font-medium text-slate-800 outline-none"
              />
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2 md:grid-cols-1">
              <ActionButton
                icon={WhatsApp}
                tone="green"
                label="WhatsApp"
                onClick={() => {
                  sendWhatsapp(list[0]?.MOBILE, list[0]?.GTOTAL);
                }}
              />
              <ActionButton
                icon={SmsOutlined}
                tone="orange"
                label="Send SMS"
                onClick={() => {
                  handleSendSms(list[0]?.MOBILE, list[0]?.GTOTAL);
                }}
              />
            </div>

            <div className="my-4 border-t border-slate-200" />
            <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Save or print</p>
            <div className="mt-3 grid grid-cols-2 gap-2 md:grid-cols-1">
              <ReactToPrint
                trigger={() => {
                  return (
                    <button
                      type="button"
                      className="inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-[#3595f0] px-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#2787df] focus:outline-none focus:ring-4 focus:ring-[#3595f0]/20"
                    >
                      <PrintRounded sx={{ fontSize: 18 }} />
                      <span>Print</span>
                    </button>
                  );
                }}
                content={() => componentRef.current}
              />
              <ActionButton icon={DownloadRounded} tone="neutral" label="Download PDF" onClick={downloadPdf} />
            </div>
            <p className="mt-4 text-xs leading-5 text-slate-500">Use the close button in the top-right when you are done.</p>
          </aside>
        </div>
      ) : (
        <div className="flex min-h-[300px] w-full items-center justify-center rounded-xl bg-white p-6">
          <div className="flex h-7 w-7 items-center">
            <Lottie
              animationData={spinner}
              loop={true}
              style={{
                fontSize: 15,
                marginTop: '15px',
              }}
              color="white"
            />
          </div>
          <div className="pl-2 text-sm font-medium text-slate-600">Loading invoice...</div>
        </div>
      )}
    </div>
  );
};

const buttonTones = {
  green: 'bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-emerald-200',
  orange: 'bg-orange text-white hover:bg-[#e97840] focus:ring-orange/20',
  blue: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-200',
  neutral: 'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-950 focus:ring-slate-200',
};

const ActionButton = React.forwardRef(({ icon: Icon, label, tone = 'neutral', onClick }, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    className={`inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg px-3 text-sm font-semibold shadow-sm transition focus:outline-none focus:ring-4 ${buttonTones[tone]}`}
  >
    <Icon sx={{ fontSize: 18 }} />
    <span>{label}</span>
  </button>
));
ActionButton.displayName = 'ActionButton';

export default ViewBill;
